
export const TabPanel = ({ active, children }) => {
    return active ? (
        <div>
            { children }
        </div>
    ) : null;
}